import { Params } from '@angular/router';

import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const PARENTS_ROUTE = {
  name: 'parents',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },
  queryParams(download: boolean): Params {
    return { download };
  },

  ACTIVITY: {
    name: 'activity',
    route(classId: string): string[] {
      return [...PARENTS_ROUTE.route(classId), this.name];
    }
  }
};
